import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box, IconButton, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import {
  LOG_MODULE_API_NAME,
  ServiceList,
  SHAREPOINT_CONN_NAME,
  WORKDRIVE_CONN_NAME,
} from "../../../config/serviceConstant";
import RootFolderSelection from "../../Service/Workdrive/RootFolderSelection/RootFolderSelection";
import * as OtherAPICalling from "../../../APICalling/Other";
import SharepointRootFolderSelection from "../../Service/Sharepoint/SharepointRootFolderSelection/SharepointRootFolderSelection";
import { Loader } from "../../atoms/Loader";
import { getRecordName } from "../../../config/otherConstant";
const warningMessage = `If you revoke it, all kinds of automation including WORKFLOWS, WIDGETS,
            BUTTONS , RELATED LIST and SETTINGS will be DISABLED`;
const ZOHO = window.ZOHO;
function EditSetting(props) {
  const {
    service,
    handleCreateSetting,
    selectedSetting,
    setSelectedSetting,
    orgid,
    apikey,
    datacenterurl,
    datacenter,
    zuid,
    setReload,
  } = props;

  const [createNewSettingOpen, setCreateNewSettingOpen] = useState(true);
  const [modules, setModules] = useState([]);
  const [modulefields, setModulefields] = useState([]);
  const [customViewList, setCustomViewList] = useState([]);
  // const [sharepointSettingData, setSharepointSettingData] = useState({});
  const [settingData, setSettingData] = useState(
    selectedSetting?.setting_schema
  );
  const [sharepointSettingData, setSharepointSettingData] = useState(
    selectedSetting?.setting_schema
  );
  const {
    register,
    getValues,
    setValue,
    resetField,
    control,
    handleSubmit,
    watch,
  } = useForm({
    defaultValues: {
      ...selectedSetting?.setting_schema,
      // service: ServiceList.find(item=> item?.apiName == JSON.parse(selectedSetting?.setting_schema)?.service?.apiName)
    },
  });

  const onSubmit = async (data) => {
    let config = {
      data: {
        settingId: selectedSetting?.setting_id || "",
        settingSchema: data,
        showInRelatedList: false,
        moduleApiName: selectedSetting?.module_name,
        settingType: "moduleCron",
      },
      orgid,
      apikey,
      datacenter,
      datacenterurl,
    };

    const upsertSettingResp = await OtherAPICalling.upsertSetting(config);

    setSelectedSetting((prev) => null);
    setCreateNewSettingOpen((prev) => !prev);
    setReload((prev) => !prev);
    // handleCreateSetting(data);
  };

  const handleClickNewSettingOpen = () => {
    setCreateNewSettingOpen(true);
  };

  const handleRevokeClose = () => {
    setCreateNewSettingOpen((prev) => false);
    setSelectedSetting((prev) => null);
  };

  useEffect(() => {
    async function fetchModuleFields() {
      try {
        const fieldsResp = await ZOHO.CRM.META.getFields({
          Entity: selectedSetting?.module_name,
        });

        const modulefields = fieldsResp?.fields
          ?.filter(
            (field) =>
              field.data_type !== "lookup" && field.data_type !== "ownerlookup"
          )
          ?.map((field) => {
            return {
              lookupApiName: "",
              lookupDisplayLabel: watch("module")?.displayLabel,
              fieldApiName: field?.api_name,
              fieldDisplayLabel: field?.display_label,
              type: field?.data_type,
            };
          });
        setModulefields((prev) => modulefields);
      } catch (error) {}
    }
    fetchModuleFields();
  }, []);

  if (modulefields?.length == 0) {
    return (
      <>
        <Dialog
          open={createNewSettingOpen}
          onClose={handleRevokeClose}
          aria-labelledby="edit-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              maxHeight: "calc(100vh - 15px)",
              display: "flex",
              flexDirection: "column",
              overflowY: "hidden",
            },
          }}
        >
          <Loader />
        </Dialog>
      </>
    );
  }

  return (
    <Dialog
      open={createNewSettingOpen}
      onClose={handleRevokeClose}
      aria-labelledby="edit-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="edit-dialog-title"
        sx={{ fontWeight: 600, fontSize: "18px", pb: 0 }}
      >
        Edit Setting
        <IconButton
          onClick={handleRevokeClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box
          id="editSettingForm"
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Service */}
          <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
            Choose Backup Platform
          </Typography>
          <Controller
            name="service"
            control={control}
            render={({ field }) => (
              <Autocomplete
                autoHighlight
                size="small"
                options={ServiceList}
                getOptionLabel={(option) => option?.displayLabel}
                disabled
                disableClearable
                value={field?.value}
                onChange={(e, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Choose Backup Platform"
                    helperText="Choose the backup platform where attacments will be saved (e.g., WorkDrive, SharePoint)."
                    fullWidth
                  />
                )}
                sx={{ mb: 1 }}
              />
            )}
          />

          {/* Module */}
          <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
            Select Module *
          </Typography>
          <Controller
            name="module"
            control={control}
            render={({ field }) => (
              <Autocomplete
                autoHighlight
                size="small"
                options={modules}
                getOptionLabel={(option) => option?.displayLabel}
                disabled
                disableClearable
                value={field?.value}
                onChange={(e, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select a CRM module"
                    helperText="Pick the CRM module for which you want to define attachment backup rules."
                    fullWidth
                  />
                )}
                sx={{ mb: 1 }}
              />
            )}
          />

          {/* Module Fields */}
          <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
            Select Fields
          </Typography>
          <Controller
            name="modulefield"
            control={control}
            render={({ field }) => (
              <Autocomplete
                autoHighlight
                size="small"
                options={modulefields}
                getOptionLabel={(option) => option?.fieldDisplayLabel}
                value={field?.value}
                onChange={(e, value) => field.onChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select CRM fields"
                    helperText="Choose the field whose values will be used to upload attachments (e.g., Workdrive Folder ID, Sharepoint Folder ID, Workdrive Folder ID(EXT), Sharepoint Folder ID (EXT))."
                    fullWidth
                    disabled={modulefields?.length === 0}
                  />
                )}
                sx={{ mb: 1 }}
              />
            )}
          />

          {/* Root Folder */}
          <Typography sx={{ fontWeight: 600, fontSize: "14px", mb: 1.5 }}>
            Select Root Folder <span style={{ color: "red" }}>*</span>
          </Typography>

          {selectedSetting?.setting_schema?.service?.apiName === "workdrive" ? (
            <RootFolderSelection
              source="setting"
              settingData={settingData}
              module={module}
              apiData={null}
              saveApiData={(data) => {}}
              saveData={(data) => {
                if (data?.key === "rootFolder" && data?.response?.id) {
                  setSettingData((prev) => ({
                    ...prev,
                    rootFolder: data.response,
                  }));
                  setValue("rootFolder", data.response);
                }
                if (data?.key === "workspace" && data?.response?.id) {
                  setSettingData((prev) => ({
                    ...prev,
                    workspace: data.response,
                  }));
                  setValue("workspace", data.response);
                }
                if (data?.key === "teamFolder" && data?.response?.id) {
                  setSettingData((prev) => ({
                    ...prev,
                    teamFolder: data.response,
                  }));
                  setValue("teamFolder", data.response);
                }
              }}
              folderDetails={null}
              setFolderDetails={(data) => {}}
              addFolder={(data) => {}}
              orgid={orgid}
              connname={WORKDRIVE_CONN_NAME}
              apikey={apikey}
              datacenterurl={datacenterurl}
              datacenter={datacenter}
              zuid={zuid}
            />
          ) : (
            <SharepointRootFolderSelection
              rootFolderID={null}
              settingData={sharepointSettingData}
              module=""
              apiData={null}
              saveApiData={(data) => {}}
              saveData={(data) => {
                if (data?.key === "rootFolder" && data?.response?.id) {
                  setSharepointSettingData((prev) => ({
                    ...prev,
                    rootFolder: data.response,
                  }));
                  setValue("rootFolder", data.response);
                }
                if (data?.key === "workspace" && data?.response?.id) {
                  setSharepointSettingData((prev) => ({
                    ...prev,
                    site: data.response,
                  }));
                  setValue("site", data.response);
                }
                if (data?.key === "teamFolder" && data?.response?.id) {
                  setSharepointSettingData((prev) => ({
                    ...prev,
                    drive: data.response,
                  }));
                  setValue("drive", data.response);
                }
              }}
              folderDetails={null}
              setFolderDetails={(data) => {}}
              addFolder={(data) => {}}
              orgid={orgid}
              connname={SHAREPOINT_CONN_NAME}
              apikey={apikey}
              datacenterurl={datacenterurl}
              zuid={zuid}
              settingUrl={process.env.REACT_APP_DRIVEMANAGER_SETTING_URL}
            />
          )}
          <Typography
            sx={{
              fontSize: "13px",
              ml: 2,
              fontWeight: 400,
              color: "#6B7280",
              mt: "5px",
            }}
          >
            Select the root folder in your drive under which all folders for
            this module’s records will be created. If no folder ID exists for a
            record, a new folder will be automatically created inside this root
            folder.
          </Typography>
          {getValues("rootFolder") ? (
            <Box
              sx={{
                backgroundColor: "#F1F6FF",
                borderLeft: "3px solid #1976D2",
                color: "#333",
                fontSize: "14px",
                p: 2,
                borderRadius: 2,
                mb: 3,
                mt: 2,
              }}
            >
              {watch("service")?.apiName === "workdrive" &&
              watch("modulefield")?.fieldDisplayLabel ? (
                <Typography variant="body2">
                  <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                  attachments will be saved in record folder. This folder Id
                  should exist in{" "}
                  <strong>{getValues("modulefield")?.fieldDisplayLabel}</strong>{" "}
                  field otherwise a folder will be created for each record in
                  below structure:{" "}
                  <strong>
                    {getValues("workspace")?.name} /{" "}
                    {getValues("teamFolder")?.name} /{" "}
                    {getValues("rootFolder")?.name} /{" "}
                    {`{${getRecordName(getValues("module")?.apiName)}}__{${
                      getValues("module")?.displayLabel
                    } ID}`}
                  </strong>
                </Typography>
              ) : (
                <></>
              )}
              {watch("service")?.apiName === "workdrive" &&
              !watch("modulefield")?.fieldDisplayLabel ? (
                <Typography variant="body2">
                  <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                  attachments will be saved in record folder. Folder will be
                  created for each record in below structure:{" "}
                  <strong>
                    {getValues("workspace")?.name} /{" "}
                    {getValues("teamFolder")?.name} /{" "}
                    {getValues("rootFolder")?.name} /{" "}
                    {`{${getRecordName(getValues("module")?.apiName)}}__{${
                      getValues("module")?.displayLabel
                    } ID}`}
                  </strong>
                </Typography>
              ) : (
                <></>
              )}
              {watch("service")?.apiName === "sharepoint" &&
              watch("modulefield")?.fieldDisplayLabel ? (
                <Typography variant="body2">
                  <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                  attachments will be saved in record folder. This folder Id
                  should exist in{" "}
                  <strong>{getValues("modulefield")?.fieldDisplayLabel}</strong>{" "}
                  field otherwise a folder will be created for each record in
                  below structure:{" "}
                  <strong>
                    {getValues("site")?.name} / {getValues("drive")?.name} /{" "}
                    {getValues("rootFolder")?.name} /{" "}
                    {`{${getRecordName(getValues("module")?.apiName)}}__{${
                      getValues("module")?.displayLabel
                    } ID}`}
                  </strong>
                </Typography>
              ) : (
                <></>
              )}
              {watch("service")?.apiName === "sharepoint" &&
              !watch("modulefield")?.fieldDisplayLabel ? (
                <Typography variant="body2">
                  <strong>ℹ️ {getValues("module")?.displayLabel}</strong>{" "}
                  attachments will be saved in record folder. Folder will be
                  created for each record in below structure:{" "}
                  <strong>
                    {getValues("site")?.name} / {getValues("drive")?.name} /{" "}
                    {getValues("rootFolder")?.name} /{" "}
                    {`{${getRecordName(getValues("module")?.apiName)}}__{${
                      getValues("module")?.displayLabel
                    } ID}`}
                  </strong>
                </Typography>
              ) : (
                <></>
              )}
            </Box>
          ) : (
            <></>
          )}

          {/* Action Buttons */}
          {/*  <Box display="flex" justifyContent="flex-end" gap={2} sx={{ pt: 3 }}>
            <Button
              onClick={handleRevokeClose}
              variant="outlined"
              color="primary"
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Box> */}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
      >
        <Button onClick={handleRevokeClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button
          type="submit"
          form="editSettingForm"
          variant="contained"
          color="primary"
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditSetting;
